<template>
  <div>
    <AppBigTopMenu v-if="!screenSmall" />
    <AppSmallTopMenu v-else />
  </div>
</template>

<script>
import AppBigTopMenu from "./AppBigTopMenu";
import AppSmallTopMenu from "./AppSmallTopMenu";
export default {
  name: "AppTopMenu",
  components: {
    AppBigTopMenu,
    AppSmallTopMenu
  },
  data() {
    return {
      screenSmall: false,
    }
  },
  mounted() {
    this.monitScreenSizeChanged();
    $(window).resize(this.monitScreenSizeChanged)
  },
  methods: {
    monitScreenSizeChanged() {
      var winWide = window.screen.width;
      if (winWide >= 768) {
        this.screenSmall = false
      } else  {
        this.screenSmall = true
      }
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AppTopMenu.vue